module.exports = __webpack_public_path__ + "static/img/zggd.ca0fac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zggd.png
// module id = daOd
// module chunks = 4